import { FC, useState } from "react";
import useScreenSize from "../../../custom-hooks/useScreenSize";

interface SliderArrowLeftProps {
    className?: string;
    onClick?: () => void;
}

const SliderArrowLeft: FC<SliderArrowLeftProps> = (props) => {
    const [isHovered, setIsHovered] = useState(false);
    const { upTo650, upTo480, upTo1360, upTo540, upTo390 } = useScreenSize();

    return (
        <svg
            className={`${props.className} transition-all duration-300 ease-in-out`}
            onClick={props.onClick}
            style={{
                position: "absolute",
                top: upTo650 ? "unset" : upTo1360 ? -55 : -70,
                bottom: upTo480 ? -80 : upTo650 ? -105 : "unset",
                left: upTo390 ? 100 : upTo480 ? 116 : upTo540 ? 120 : upTo650 ? 140 : "unset",
                right: upTo650 ? "unset" : 79,
                width: upTo480 ? 37 : 55,
                height: upTo480 ? 37 : 55,
                borderRadius: 100,
                backgroundColor: isHovered ? "#F1F1F1" : "transparent",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="-0.5" y="0.5" width="54" height="54" rx="27" transform="matrix(-1 0 0 1 54 0)" stroke="black" />
            <path d="M30.5 19L21.5 27.5L30.5 36" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default SliderArrowLeft;
